/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./top-nav.vue?vue&type=template&id=8fd5acba"
import script from "./top-nav.vue?vue&type=script&lang=js"
export * from "./top-nav.vue?vue&type=script&lang=js"
import style0 from "./top-nav.vue?vue&type=style&index=0&id=8fd5acba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports